import { useEffect, useRef } from 'react'

export function useFetchOnOpen(open: boolean, onOpen: () => void) {
  const hasFetched = useRef(false)

  useEffect(() => {
    if (open && !hasFetched.current) {
      hasFetched.current = true
      onOpen()
    }
    if (!open) {
      hasFetched.current = false
    }
  }, [open, onOpen])
}
